import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import App from 'modules/App';
import * as actions from '../actions';
import { RESET_PASSWORD_FORM } from '../constants';
import * as selectors from '../selectors';
export const useClearResetPassword = ()=>{
    const otpStatus = useSelector(selectors.otpStatus);
    const clearOtp = useAction(actions.clearOtp);
    const resetPasswordCancel = useAction(actions.resetPasswordCancel);
    const setResetPasswordType = useAction(actions.setResetPasswordType);
    const clearForm = useAction(App.actions.clearForm, RESET_PASSWORD_FORM);
    const clear = useCallback(()=>{
        resetPasswordCancel();
        clearForm();
        clearOtp();
        setResetPasswordType(null);
    }, []);
    useEffect(()=>()=>{
            if (otpStatus) clear();
        }, []);
    return clear;
};
